import type React from 'react';

import { Alert } from '@mui/material';

import { AutosaveStopReason } from '@/components/emailWindow/util/useEmailDraftController.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type Props = {
  reason: AutosaveStopReason | null;
};

export const NewEmailAutosaveAlert: React.FC<Props> = ({ reason }) => {
  const { t } = useTranslationWithPrefix('views.emails.newEmail.autosave');

  if (!reason) {
    return null;
  }

  return (
    <Alert severity={reason === 'rejected' ? 'warning' : 'info'} sx={{ borderRadius: 0 }}>
      {t(reason)}
    </Alert>
  );
};
